import { render, staticRenderFns } from "./LocationsNewModal.vue?vue&type=template&id=c615500a&"
import script from "./LocationsNewModal.vue?vue&type=script&lang=js&"
export * from "./LocationsNewModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports